import React from 'react';
import PropTypes from 'prop-types';
import Stars from '../hotels/stars';
import '../../packs/translations';

const Term = (props) => {
  return (
    <div className="offers-list__item">
      <a href={props.hotel_path} className="offers-list__img loader_on_click">
        {props.hotel_image_url && <img src={props.hotel_image_url} alt={props.label_for_term} />}
        <div className={`offers-list__badge ${props.badge_class}`}>
          {props.homepage &&
            <React.Fragment>
              <span className="price">
                {props.price_label}
              </span>
              <span>
                {`${props.days} ${I18n.t('js.show_tour.days')} | ${props.meals} | ${I18n.t('js.show_tour.by_air')}`}
              </span>
            </React.Fragment>
          }
          <span className="status">
            {props.tour_type}
          </span>
        </div>
        <div className="offers-list__item__hover">
          <span className="ico">
            <i className="fas fa-globe-americas" />
          </span>
          <span>
            {I18n.t('js.show_tour.read_more')}
            <i className="fas fa-chevron-right" />
          </span>
        </div>
      </a>
      <div className="offers-list__content">
        <div className="offers-list__content__info">
          <span className="stars text-secondary">
            <Stars count={props.hotel_stars} />
          </span>
          <span className="place">
            <i className="fas fa-map-marker-alt" />
            <span dangerouslySetInnerHTML={{__html: props.hotel_destination}} />
          </span>
          <span className="food" dangerouslySetInnerHTML={{__html: props.meals}}>
          </span>
          <span className="transport" dangerouslySetInnerHTML={{__html: props.transport}}>
          </span>
        </div>
        <h3 className="title-h3">
          <a href={props.hotel_path} className="loader_on_click">{props.label_for_term}</a>
        </h3>
        <div className="offers-list__content__date">
          {`${props.current_date_start} - ${props.current_date_end} `}
          (<strong>{props.days}</strong>{` ${I18n.t('js.show_tour.days')}`})
        </div>
        {!props.homepage &&
          <div className="price">
            {props.price_label}
          </div>
        }
        <div dangerouslySetInnerHTML={{__html: props.extra_info}} />
      </div>
    </div>
  );
}

Term.propTypes = {
  homepage: PropTypes.bool.isRequired,
  id: PropTypes.number.isRequired,
  hotel_path: PropTypes.string.isRequired,
  hotel_image_url: PropTypes.string,
  hotel_stars: PropTypes.number.isRequired,
  hotel_destination: PropTypes.string.isRequired,
  meals: PropTypes.string.isRequired,
  transport: PropTypes.string.isRequired,
  label_for_term: PropTypes.string.isRequired,
  current_date_start: PropTypes.string.isRequired,
  current_date_end: PropTypes.string.isRequired,
  days: PropTypes.number.isRequired,
  extra_info: PropTypes.string.isRequired,
  price_label: PropTypes.string.isRequired,
  tour_type: PropTypes.string.isRequired,
  badge_class: PropTypes.string.isRequired
}

Term.defaultProps = {
  homepage: false,
  badge_class: ''
}

export default Term;